import { Organizer } from "@/apiTypes/event";
import { Profile, PublicProfile } from "@/apiTypes/profile";
import { cn } from "@/lib/utils";
import { getProfileName } from "@/utils/getProfileName";
import { FC } from "react";

interface AvatarProps {
  profile?: PublicProfile;
  organizer?: Organizer;
  className?: string;
}

/**
 * Renders an avatar image, or an initial fallback. Supports profiles and organizations
 */
export const Avatar: FC<AvatarProps> = ({ className, profile, organizer }) => {
  if (profile) {
    const name = getProfileName(profile);
    const initial = name.charAt(0).toUpperCase();

    if (profile.avatarUrl) {
      return (
        <img
          src={profile.avatarUrl}
          alt={name}
          className={cn("w-8 h-8 rounded-full object-cover", className)}
          referrerPolicy="no-referrer"
        />
      );
    }

    return (
      <div
        className={cn(
          "w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xs font-semibold",
          className,
        )}
      >
        {initial}
      </div>
    );
  }

  if (organizer) {
    if (organizer.logoUrl) {
      return (
        <img
          src={organizer.logoUrl}
          alt={organizer.name}
          className={cn("w-8 h-8 rounded-full object-cover", className)}
          referrerPolicy="no-referrer"
        />
      );
    }

    const initial = organizer.name.charAt(0).toUpperCase();
    return (
      <div
        className={cn(
          "w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xs font-semibold",
          className,
        )}
      >
        {initial}
      </div>
    );
  }

  return null;
};
